import ArrowsRightIcon from "@redotech/redo-icons/arrows-right_filled.svg";
import { Step } from "@redotech/redo-model/return-flow";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export interface SeparateLabelsState {
  customTitle?: string;
}

export namespace SeparateLabelsState {
  export function valid(_state: SeparateLabelsState): boolean {
    return true;
  }
}

export const SEPARATE_LABELS = (
  Details: React.ComponentType<StepTypeDetailsProps<SeparateLabelsState>>,
): StepType<SeparateLabelsState, Step.SeparateLabels> => ({
  layout() {
    return BlockLayout.FULL;
  },
  empty: {},

  title: "Separate labels",

  customTitle: (state) => state.customTitle,

  description: () => {
    return "Items get their own label";
  },

  Icon: ArrowsRightIcon,
  iconColor: "success",

  Details(props) {
    return <Details {...props} />;
  },

  downstream: () => [],

  maxDownstream: () => 0,

  fromModel: (model) => ({ customTitle: model.customTitle }),

  toModel: (state) => ({
    type: Step.SEPARATE_LABELS,
    customTitle: state.customTitle,
  }),

  valid: (state) => SeparateLabelsState.valid(state),

  stepDeleted: (state) => state,
});
